import type {ParameterDefinitionType} from '@volkswagen-onehub/vw-starter-framework';
import type {BffQueryParams} from '../default/parameter';
import type {BffResponse} from '../default/response';
import {defaultParameterDefinition} from '../definitions';

interface RouterType<P, R> {
  requestParameters: P;
  payloadType: R;
}

export interface BffRoutes {
  default: RouterType<BffQueryParams, BffResponse>;
}

export type BffName = keyof BffRoutes;

/**
 * Used by feature apps.
 */
export type BffRoutePath<R extends BffName> = `/bff/${R}`;

/**
 * Generic display of bffs in the integrator
 */

export interface RouteDefinition<T extends BffName> {
  path: BffRoutePath<T>;
  requestParameters: ParameterDefinitionType<BffRoutes[T]['requestParameters']>;
  httMethod?: 'GET' | 'POST';
}

export type RouteDefinitions = {
  [Key in BffName]: RouteDefinition<Key>;
};

/**
 * Used to display bffs in integrator
 */
export const routesDefinition: RouteDefinitions = {
  default: {
    requestParameters: defaultParameterDefinition,
    path: '/bff/default',
  },
};
